import AdvertorialList from './AdvertorialList';
import { ADVERTORIAL } from './advertorial.navigation';

const advertorialRoute = { ...ADVERTORIAL, component: AdvertorialList };

export default advertorialRoute;
